export default "__VITE_ASSET__DnwnkrSV__"